import TradingViewWidget, { Themes } from "react-tradingview-widget";

import useChangeTheme from "hooks/useChangeTheme";

function TradingViewChart({ symbol, height }) {
  const changeTheme = useChangeTheme();

  const setThemeForChart = () => {
    if (changeTheme.theme === "secondary") {
      return Themes.LIGHT;
    }

    return Themes.DARK;
  };

  return (
    <TradingViewWidget
      symbol={symbol === "OUNCE" ? "GOLD" : symbol + "USDT"}
      width="100%"
      height={height || "400"}
      theme={setThemeForChart()}
    />
  );
}
export default TradingViewChart;
